import { useEffect, useState } from 'react';

export const useFirstInteraction = (callback: () => void) => {
  const [wasInteracted, setWasInteracted] = useState(false);

  useEffect(() => {
    if (wasInteracted) return;

    const handleInteraction = () => {
      if (wasInteracted) return;

      setWasInteracted(true);
      callback();

      window.removeEventListener('mousemove', handleInteraction);
      window.removeEventListener('touchstart', handleInteraction);
    };

    window.addEventListener('mousemove', handleInteraction, { passive: true });
    window.addEventListener('touchstart', handleInteraction, { passive: true });

    return () => {
      window.removeEventListener('mousemove', handleInteraction);
      window.removeEventListener('touchstart', handleInteraction);
    };
  }, [callback, wasInteracted]);

  return wasInteracted;
};
